import types from '../types/calendar'
import startTypes from '../types/start'
import addressTypes from '../types/address'
import {Map, List} from 'immutable'
import moment from '../../../common/moment'
import depositTypes from '../types/deposit'

const initialRoot = Map({
  date: null,
  unavailableDates: List(),
  timeslot: 0,
  timeslots: List(),
  lastTimeslotFetchID: 0,
  isFetchingDates: false,
  isFetchingTimeslots: false,
  isFetchingAddresses: false,
  address: 0,
  addresses: List(),
  isModifying: false,
  error: '',
})

function root(state = initialRoot, action) {
  switch (action.type) {
    case startTypes.GET_TRANSACTION_SUCCESS:
      const transaction = action.payload.transaction
      return state.merge({
        // date: moment.utc(transaction.Reserve.Date),
        address: transaction.ClientAddress ? transaction.ClientAddress.ID : 0,
        timeslot: transaction.Reserve.TimeSlot.ID,
      })
    case types.SELECT_DATE:
      return state.merge({
        date: action.payload.date,
        timeslot: 0,
      })
    case types.GET_UNAVAILABLE_DATES:
      return state.merge({
        isFetchingDates: true,
        error: '',
      })
    case types.GET_UNAVAILABLE_DATES_SUCCESS:
      return state.merge({
        unavailableDates: action.payload.dates.map(d => moment(d)),
        isFetchingDates: false,
        error: '',
      })
    case types.GET_UNAVAILABLE_DATES_FAIL:
      return state.merge({
        isFetchingDates: false,
        error: action.payload.error,
      })
    case types.SELECT_TIMESLOT:
      return state.set('timeslot', action.payload.timeslot)
    case types.GET_TIMESLOTS:
      return state.merge({
        isFetchingTimeslots: true,
        error: '',
        lastTimeslotFetchID: action.payload.lastTimeslotFetchID
      })
    case types.GET_TIMESLOTS_SUCCESS:
      return state.merge({
        timeslots: action.payload.timeslots,
        isFetchingTimeslots: false,
        error: '',
      })
    case types.GET_TIMESLOTS_FAIL:
      return state.merge({
        isFetchingTimeslots: false,
        error: action.payload.error,
      })
    case types.MODIFY_TRANSACTION:
      return state.merge({
        isModifying: true,
        error: '',
      })
    case types.MODIFY_TRANSACTION_SUCCESS:
      return state.merge({
        isModifying: false,
        error: '',
      })
    case types.MODIFY_TRANSACTION_FAIL:
      return state.merge({
        isModifying: false,
        error: action.payload.error,
      })
    case addressTypes.FETCH:
      return state.merge({
        isFetchingAddresses: true,
        error: '',
      })
    case addressTypes.FETCH_SUCCESS:
      return state.merge({
        isFetchingAddresses: false,
        addresses: List(action.payload.addresses),
        error: '',
      })
    case addressTypes.FETCH_FAIL:
      return state.merge({
        isFetchingAddresses: false,
        error: action.payload.error,
      })
    case addressTypes.SET_SELECTED:
      return state.set('address', action.payload.selected)
    case depositTypes.START:
      return initialRoot
    default:
      return state
  }
}

export default root



// WEBPACK FOOTER //
// ./src/sections/depositV2/reducers/calendar.js